export const createColumnOptions = (columns, hiddenColumns) => {
  return columns.map((item) => {
    return {
      label: item,
      value: item,
      hidden: hiddenColumns.includes(item),
    };
  });
};
